
import * as ipxRuntime$W0Xhq42l27 from '/home/nuxt-front-end-V2/nuxt-front-end/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 75
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$W0Xhq42l27, defaults: {} }
}
        